import React from 'react';
import './App.css';
import { useAuth } from './contexts/AuthContext';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Account from './components/Account';
import Support from './components/Support';
import Bookmarks from './components/Bookmarks';
import Presentations from './components/Presentations';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import OAuthCallback from './components/OAuthCallback';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

function App() {
  const { user, loading } = useAuth();
  const location = useLocation();
  // Render OAuth callback page standalone (no NavBar / Footer)
  if (location.pathname.startsWith('/auth/callback')) {
    return <OAuthCallback />;
  }
  if (loading) return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <CircularProgress />
    </Box>
  );
  if (!user) return <Login />;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <NavBar />
      <Container sx={{ mt: 4, mb: 4, flex: 1 }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/account" element={<Account />} />
          <Route path="/subscriptions" element={<Account />} />
          <Route path="/support" element={<Support />} />
          <Route path="/bookmarks" element={<Bookmarks />} />
          <Route path="/presentations" element={<Presentations />} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Container>
      <Footer />  
    </Box>
  );
}

export default App;
